var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.977 1.075c3.78-.982 3.522 7.824-1.567 17.684-4.519 8.753-10.205 20.239-13.74 16.523-3.226-3.394 5.533-7.145 18.903-10.628 13.37-3.484 20.6-2.941 19.271.625-1.199 3.215-8.936-.81-15.675-8.485-6.823-7.77-12.1-14.444-7.192-15.719z",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  })));
};
export default SvgPdf;